import BaseApi from "./BaseApi"

const AUTH_ENDPOINT = "/auth"
const SPRINT_AUTH_ENDPOINT = "/api/saml2"

class AuthApi extends BaseApi {

  getLocalDnsValue() {
    const allCookies = document.cookie

    if (!allCookies
      .split(";")
      .filter((cookie) => {
        return cookie.trim().indexOf("dnt=") === 0
      }).length) {
      return "0" // no cookie equals "Sell"
    }

    const localDnsCookie = allCookies
      .split(";")
      .filter((cookie) => {
        return cookie.trim().indexOf("dnt=") === 0
      })[0]

    return localDnsCookie
      .substring(localDnsCookie.indexOf("=") + 1, localDnsCookie.length) === "1"
      ? "1"
      : "0"
  }

  async loginWithBan(ban) {
    try {
      const endpoint = `${AUTH_ENDPOINT}/ban`
      const response = await this.post(endpoint, {ban: ban})
      const {data: user} = response

      this.setAuthToken(user.userToken)

      return user

    } catch (error) {
      throw new Error("Unable to log in with BAN")
    }
  }

  async loginWithTmoId(tmoToken) {
    try {
      const endpoint = `${AUTH_ENDPOINT}/code`
      const response =  await this.post(endpoint, {code: tmoToken})
      const {data: user} = response

      this.setAuthToken(user.userToken)

      return user

    } catch (error) {
      throw new Error("Unable to log in with TMO ID")
    }
  }

  async userTokenHeaderCallback(token) {
    try {
      const endpoint = `${AUTH_ENDPOINT}/httpHeaderCallback`
      const response =  await this.post(endpoint, {token: token})
      const {data: user} = response

      this.setAuthToken(user.userToken)

      return user

    } catch (error) {
      throw new Error("Unable to log in with TMO ID")
    }
  }

  async loginWithSprintToken(samlToken, phoneNumber) {
    try {
      this.setAuthToken(samlToken)

      const endpoint = `${SPRINT_AUTH_ENDPOINT}/authSprintUser?phoneNumber=${phoneNumber}`
      const response =  await this.get(endpoint)
      const {data: user} = response

      this.setAuthToken(user.userToken)

      return user

    } catch (error) {
      throw new Error("Unable to log in with Sprint")
    }
  }

  async getGlobalDnsSetting(tMobileId) {
    try {
      const dnsValue = this.getLocalDnsValue()
      const endpoint = `${AUTH_ENDPOINT}/dnsSetting`
      const response = await this.post(endpoint, {tMobileId: tMobileId, doNotSellValue: dnsValue})
      const {data: dns} = response

      return dns
    } catch (error) {
      throw new Error("Unable to retrieve DNS setting")
    }
  }

  async getGlobalDnsSettingV2(tMobileId) {
    try {
      const dnsValue = this.getLocalDnsValue()
      const endpoint = `${AUTH_ENDPOINT}/getDnsSettingV2`
      const response = await this.post(endpoint, {tMobileId: tMobileId, doNotSellValue: dnsValue})
      const {data: dnsV2} = response

      return dnsV2
    } catch (error) {
      throw new Error("Unable to retrieve DNS setting")
    }
  }

  async setGlobalDnsSetting(tMobileId, dnsValue){
    try {
      const endpoint = `${AUTH_ENDPOINT}/setDnsSetting`
      const response = await this.post(endpoint, {tMobileId: tMobileId, doNotSellValue: dnsValue})
      return response
    } catch (error) {
      throw new Error("Unable to set the DNS setting")
    }
    
  }

  async getCompanyLookup(msisdn) {
    try {
      const endpoint = `${AUTH_ENDPOINT}/msisdncompanylookup/${msisdn}`
      const response = await this.get(endpoint)
      return response.data
    } catch (error) {
      throw new Error("Unable to retrieve cross company lookup")
    }
  }

  async setTfbUserInfo(user) {
      try {
          const endpoint = `${AUTH_ENDPOINT}/tfbUserInfo/`
          const response = await this.post(endpoint, user)

          this.setAuthToken(response.data.userToken)
          return response.data
      } catch (err) {
          return null
          //throw new Error("Unable to retrieve User Info")
      }
  }
}

export default new AuthApi()
